import { useContext } from 'react';
import { PeriodSelectionContext } from './period-selection-context';

export const usePeriodSelection = () => {
  const context = useContext(PeriodSelectionContext);

  if (!context) {
    throw new Error('usePeriodSelection must be used within a PeriodSelectionContext');
  }

  return context;
};
